import React from 'react';

const Loading = () => {
    return (<div className="text-center m-5">
        <div className="spinner-grow text-primary" role="status">
            <span className="sr-only">Loading...</span>
        </div>
    </div>);
}

export default Loading;